import api from './api.service'

export const expectedAnswerImportConfigurationService = {
    list,
    get,
    save,
    update,
    _delete,
    triggerNow
};

const BASE_URL = '/expectedAnswerImportConfigurations'

function list(max) {
    return api.get(BASE_URL, {max: max || 100, sort: 'id', order: 'asc'})
}

function get(id) {
    return api.get(BASE_URL + '/' + id)
}

function save(expectedAnswerImportConfiguration) {
    return api.post(BASE_URL, expectedAnswerImportConfiguration)
}

function update(id, expectedAnswerImportConfiguration) {
    return api.put(BASE_URL + "/" + id, expectedAnswerImportConfiguration)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}

function triggerNow(id) {
    return api.get('/expectedAnswerImportConfiguration/triggerNow/' + id)
}
